<template>
    <ImageViewerModal ref="imageViewerModalRef" />
    <div class="image-card" @click="onViewImage(image)">
        <div class="image-card__icon">
            <Image class="image-card__icon text-muted" />
        </div>

        <span class="image-card__filename">
            {{ image.fileName }}
        </span>

        <div
            class="image-card__download"
            @click.stop="onDownloadImage(image)"
        >
            <Download class="image-card__download__icon" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { Download, Image } from 'lucide-vue-next'
import { ImageDetailsDto } from '@/api/generated/HCA'
import ImageViewerModal from '@/pages/generators/images/ImageViewerModal.vue'
import { ref } from 'vue'
import { useGeneratorImageBlobDownloads } from '@/composables/useGeneratorImageBlobDownloads'

defineProps<{
    image: ImageDetailsDto
}>()

const { downloadImage } = useGeneratorImageBlobDownloads()
const imageViewerModalRef = ref<InstanceType<typeof ImageViewerModal> | null>(null)

const onViewImage = (image: ImageDetailsDto) => {
    imageViewerModalRef.value?.openModal(image)
}

const onDownloadImage = (image: ImageDetailsDto) => {
    downloadImage(image)
}
</script>

<style scoped lang="scss">
.image-card {
    min-width: 320px;
    
    display: inline-flex;
    align-items: center;
    gap: $spacing-s;
    
    padding: $spacing-m $spacing-m;
    background-color: $pbl-background;
    border: 1px solid $pbl-foreground-muted;
    border-radius: 4px;

    cursor: pointer;

    &:hover {
        transition: border-color 0.2s ease;
        border-color: $pbl-primary;
    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 24px;
        height: 24px;
        border-radius: 4px;
        color: $pbl-text-muted;
    }

    &__filename {
        flex: 1;
        
        font-size: $default-font-size;
        font-weight: 500;
        color: $pbl-text;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__download {
        display: flex;
        align-items: center;
        justify-content: center;
        
        border-radius: 4px;
        flex-shrink: 0;

        &__icon {
            width: 20px;
            height: 20px;
            color: $pbl-primary;
        }
    }
}
</style>
